//  This is a generated file, do not edit it directly
import SvgIcon from '@mui/material/SvgIcon';
import type { TpBaseSvgIconProps } from '../types/muiSvgIcon';
import { SvgChevronDown } from '../icons/ChevronDown';

export function ChevronDownIcon(props: TpBaseSvgIconProps): React.ReactElement {
  return (
    <SvgIcon {...props} component={SvgChevronDown} data-qa="ChevronDownIcon">
      <svg />
    </SvgIcon>
  );
}
